import React, { useCallback, useEffect, useState } from "react";
import "./unsubscribe.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Loader from "./Loader";
import { blobURL } from "common/StringUtils";
import { useTranslation } from "react-i18next";

function Unsubscribed() {
  const location = useLocation();

  const [isUnsubscribed, setIsUnsubscribed] = useState(false);
  const [isSubscribed, setIssubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState(
    "Server Error, Please contact Administrator"
  );
  const [optionToResubscribe, setOptionToReSubscribe] = useState(false);
  const { t } = useTranslation();

  const unsubscribeScript = useCallback(async () => {
    setLoading(true);
    if (location?.search) {
      const searchParams = new URLSearchParams(location.search);
      const template = searchParams.get("template");
      const email = searchParams.get("email");

      if (template && email) {
        try {
          const URL = `/adminemailtemplate/unsubscribed?data=${email}&template=${template}`;
          const result = await axios.post(URL);
          if (result.status === 200) {
            setLoading(false);
            setIsUnsubscribed(true);
          }
        } catch (error) {
          setLoading(false);
          if (error?.response?.status === 404) {
            setIsUnsubscribed(false);
            setOptionToReSubscribe(true);
            setErrorText(
              "Your unsubscribe request has already been processed."
            );
          }
        }
      } else {
        setErrorText(t("Server Error, Please contact Administrator"));

        setLoading(false);
      }
    } else {
      setErrorText(t("Server Error, Please contact Administrator"));

      setLoading(false);
    }
  }, [location, t]);

  useEffect(() => {
    unsubscribeScript();
  }, [unsubscribeScript]);

  const subscribeAgain = async () => {
    setLoading(true);
    try {
      const searchParams = new URLSearchParams(location.search);
      const email = searchParams.get("email");
      const template = searchParams.get("template");

      if (email && template) {
        const URL = `/adminemailtemplate/subscribed?data=${email}&template=${template}`;
        const result = await axios.post(URL);
        if (result.status === 200) {
          setIssubscribed(true);
          setIsUnsubscribed(false);
          setLoading(false);
        }
      } else {
        setErrorText(t("Server Error, Please contact Administrator"));
        setIssubscribed(false);
        setIsUnsubscribed(false);
        setLoading(false);
      }
    } catch (error) {
      setIssubscribed(false);
      setIsUnsubscribed(false);
      setErrorText(t("Server Error, Please contact Administrator"));
      setLoading(false);
    }
  };

  const mainLogoNew = `${blobURL}/fakt-logo.png`;

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {" "}
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <a className="navbar-brand" href="#" style={{ cursor: "default" }}>
              <img
                className="mr-md-4 ml-4 mr-2 logo  img-fluid"
                src={mainLogoNew}
                alt="site-logo"
                height={100}
                width={100}
                loading="lazy"

                // onClick={() => navigate("/")}
              />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </nav>
          <div className="bg_clr">
            <div className="row justify-content-center w-100">
              <div className="col-lg-4">
                <div className="unsubscribe-container">
                  <div className="unsubscribe-success">
                    <div className="icon-container">
                      <i className="fas fa-check-circle success-icon"></i>
                    </div>
                    {isUnsubscribed ? (
                      <div className="text-center">
                        <h1 className="success-heading">
                          {t("Your subscription is officially cancelled")}
                        </h1>
                        <p className="success-message">
                          {t(
                            "We are grateful for your support during your time with us."
                          )}
                        </p>
                        <div className="msg">
                          <p>
                            {t("Unsubscribed by mistake?")}
                            <span onClick={subscribeAgain}>
                              {t("Subscribe again")}
                            </span>
                          </p>
                        </div>
                      </div>
                    ) : isSubscribed ? (
                      <div className="text-center">
                        <h1 className="success-heading">
                          {t("WELCOME BACK!")}{" "}
                        </h1>
                        <p className="success-message">
                          {t("You have opted in to receive emails again")}
                        </p>
                      </div>
                    ) : (
                      <>
                        <p className="success-message">{t(errorText)}</p>
                        {optionToResubscribe && (
                          <div className="msg">
                            <p>
                              {t("Unsubscribed by mistake?")}
                              <span onClick={subscribeAgain}>
                                {t("Subscribe again")}
                              </span>
                            </p>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Unsubscribed;
